import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import './i18n' // Import the i18n configuration

// 'localhost' and '127.0.0.1' are different origins to the browser (separate
// localStorage/cookies) even though they hit the same machine — visiting one
// after logging in via the other loses the whole POS session (token,
// pos_restaurant_id, current_pos_id...) and the app can't resolve a restaurant
// anymore. Canonicalize to localhost before anything else runs so it can't
// happen regardless of which URL someone typed, bookmarked, or was given.
if (window.location.hostname === '127.0.0.1') {
  window.location.replace(window.location.href.replace('127.0.0.1', 'localhost'));
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
